import { observable } from "mobx";
import { Type } from "class-transformer";
import OutgoingPayGatePaymentStatus from "./outgoingPayGatePaymentStatus";
import RefundChargeResponse from "./refundChargeResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class OutgoingPayGatePaymentResponse {
  id!: string;

  @observable
  @Type(() => Date)
  authorizedDate?: Date;

  @observable
  @Type(() => Date)
  exportedDate?: Date;

  @observable
  variableSymbol?: number;

  @observable
  paidAmount!: number;

  @observable
  cardNumber?: string;

  @observable
  arn?: string;

  @observable
  refundReason?: string;

  @observable
  @Type(() => RefundChargeResponse)
  searchedCharge?: RefundChargeResponse;

  @observable
  status!: OutgoingPayGatePaymentStatus;
}
